import type {AppRoute} from '../routes';

export const SITE_URL = 'https://dashless.autos';

export type RouteSeo = {
  title: string;
  description: string;
  url: string;
};

const HOME_SEO: RouteSeo = {
  title: 'Dashless | iOS Speedometer & OBD2 Dashboard',
  description:
    'Dashless is a clean iOS driving dashboard with full-screen speedometer, OBD2 telemetry, and premium EV, hybrid, gasoline, and diesel odometer themes.',
  url: `${SITE_URL}/`,
};

const SUPPORT_SEO: RouteSeo = {
  title: 'Dashless Support | Help for Dashless iOS App',
  description:
    'Get support for Dashless on iOS, including setup help, OBD2 compatibility guidance, purchase support, and troubleshooting.',
  url: `${SITE_URL}/support`,
};

const IOS_PRIVACY_SEO: RouteSeo = {
  title: 'Dashless iOS Privacy Policy',
  description:
    'Read the Dashless iOS privacy policy, including how location, Bluetooth, telemetry, diagnostics, and purchase data are handled.',
  url: `${SITE_URL}/ios-privacy`,
};

export function getRouteSeo(route: AppRoute): RouteSeo {
  if (route === 'support') {
    return SUPPORT_SEO;
  }

  if (route === 'ios-privacy') {
    return IOS_PRIVACY_SEO;
  }

  return HOME_SEO;
}

function setMetaTag(selector: string, content: string): void {
  const meta = document.head.querySelector(selector);
  if (meta instanceof HTMLMetaElement) {
    meta.setAttribute('content', content);
  }
}

function setCanonical(url: string): void {
  const link = document.head.querySelector('link[rel="canonical"]');
  if (link instanceof HTMLLinkElement) {
    link.setAttribute('href', url);
  }
}

export function applyRouteSeo(routeSeo: RouteSeo): void {
  document.title = routeSeo.title;
  setMetaTag('meta[name="description"]', routeSeo.description);
  setMetaTag('meta[property="og:title"]', routeSeo.title);
  setMetaTag('meta[property="og:description"]', routeSeo.description);
  setMetaTag('meta[property="og:url"]', routeSeo.url);
  setMetaTag('meta[name="twitter:title"]', routeSeo.title);
  setMetaTag('meta[name="twitter:description"]', routeSeo.description);
  setCanonical(routeSeo.url);
}
